// extracted by mini-css-extract-plugin
export default {"content":"content--mp-Df0Zi","header":"header--mp-qSGhv"};